import { render } from "./EstatisticasCharts.vue?vue&type=template&id=a167ab3e"
import script from "./EstatisticasCharts.vue?vue&type=script&lang=js"
export * from "./EstatisticasCharts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__